<template>
  <div class="question row">
    <div :class="typeView === 'view-result' ? 'col-xl-5 mb-4 mb-xl-0' : 'col-12'">
      <div class="card pronunciation-preview-card h-100">
        <div class="card-body">
          <homework-container :question="question"></homework-container>

          <div v-if="typeView === 'view-result'" class="preview-panel mt-4">
            <div class="preview-panel__title">Bài làm</div>
            <div class="preview-panel__body">
              <div v-if="answerUrl" class="media-wrap">
                <audio v-if="mediaType === 'audio'" class="w-100 clean-audio" controls preload="auto">
                  <source :src="answerUrl" type="audio/ogg">
                  <source :src="answerUrl" type="audio/mpeg">
                  <source :src="answerUrl" type="audio/wav">
                </audio>
                <video v-else-if="mediaType === 'video'" class="media-player" controls preload="auto">
                  <source :src="answerUrl" type="video/mp4">
                  <source :src="answerUrl" type="video/webm">
                  <source :src="answerUrl" type="video/ogg">
                </video>
                <div v-else class="text-muted">Không xác định được định dạng bài làm.</div>
              </div>
              <div v-else class="text-muted">Chưa có câu trả lời</div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div v-if="typeView === 'view-result'" class="col-xl-7">
      <div class="card pronunciation-score-card">
        <div class="card-body">
          <div class="section-heading mb-4">Chấm bài</div>

          <div class="score-box">
            <div class="score-box__label">Điểm toàn bài</div>
            <div class="score-box__value-wrap">
              <el-rate
                class="admin-rate"
                size="large"
                :max="10"
                :show-score="true"
                :value="totalScore"
                :disabled="true"
                allow-half
              />
            </div>

            <div v-if="comments.length" class="mt-4">
              <label class="field-label mb-2">Nhận xét</label>
              <div v-for="(comment, index) in comments" :key="index" class="mb-3">
                <div v-if="comment.type === 'file' && comment.totalScore" class="audio-box">
                  <audio controls class="audio-player clean-audio">
                    <source :src="normalizeUrl(comment.totalScore)" type="audio/wav">
                    <source :src="normalizeUrl(comment.totalScore)" type="audio/mpeg">
                    <source :src="normalizeUrl(comment.totalScore)" type="audio/ogg">
                    Trình duyệt không hỗ trợ phát audio.
                  </audio>
                </div>
                <div v-else class="comment-text-box">
                  <p class="comment-text">{{ comment.totalScore || '' }}</p>
                </div>
              </div>
            </div>

            <div v-else class="comment-text-box mt-4">
              <p class="comment-empty">Không có nhận xét</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import homeworkContainer from './homework-container.vue'

const AUDIO_EXTENSIONS = ['.mp3', '.wav', '.ogg', '.m4a', '.aac']
const VIDEO_EXTENSIONS = ['.mp4', '.webm', '.ogv', '.mov', '.m4v', '.3gp', '.mpeg']

export default {
  name: 'pronunciation',
  components: {
    homeworkContainer: homeworkContainer
  },
  props: {
    question: {
      type: Object,
      default: function () {
        return {}
      }
    },
    typeView: {
      type: String,
      default: ''
    }
  },
  computed: {
    outComes() {
      return this.question?.outComes || {}
    },
    totalScore() {
      return this.outComes?.score ?? 0
    },
    comments() {
      const commentsData = this.parseMaybeJson(this.outComes?.comments, [])
      const generalComments = this.parseMaybeJson(this.outComes?.general_comments, [])

      if (Array.isArray(generalComments) && generalComments.length) {
        return generalComments
      }

      if (Array.isArray(commentsData) && commentsData.length && commentsData[0]?.totalScore !== undefined) {
        return commentsData
      }

      if (this.outComes?.comment) {
        return [{ totalScore: this.outComes.comment, type: 'text' }]
      }

      return []
    },
    answerUrl() {
      const answer = this.question?.questions?.[0]?.student_answer || this.outComes?.answer || this.question?.student_answer || ''
      return this.normalizeUrl(answer)
    },
    mediaType() {
      const url = this.answerUrl
      if (!url) {
        return null
      }

      const normalizedUrl = url.split('?')[0].toLowerCase()
      if (VIDEO_EXTENSIONS.some((ext) => normalizedUrl.endsWith(ext))) {
        return 'video'
      }
      if (AUDIO_EXTENSIONS.some((ext) => normalizedUrl.endsWith(ext))) {
        return 'audio'
      }
      return null
    }
  },
  methods: {
    parseMaybeJson(value, fallback) {
      if (value === null || value === undefined || value === '') {
        return fallback
      }

      if (typeof value === 'string') {
        try {
          return JSON.parse(value)
        } catch (error) {
          return fallback
        }
      }

      return value
    },
    normalizeUrl(value) {
      if (!value || typeof value !== 'string') {
        return value || ''
      }

      if (value.indexOf('://') > -1 || value.indexOf('blob:') === 0 || value.indexOf('data:') === 0) {
        return value
      }

      return 'https://' + value
    }
  }
}
</script>

<style lang="scss" scoped>
.pronunciation-preview-card,
.pronunciation-score-card {
  border: 1px solid #e4e6ef;
  border-radius: 0.75rem;
  box-shadow: 0 0.5rem 1.5rem rgba(140, 152, 164, 0.08);
}

.section-heading {
  font-size: 1.05rem;
  font-weight: 700;
  text-transform: uppercase;
  color: #3f4254;
  letter-spacing: 0.04em;
}

.preview-panel,
.score-box {
  padding: 1rem;
  border: 1px solid #e4e6ef;
  border-radius: 0.75rem;
  background: #f8f9fc;
}

.preview-panel__title,
.score-box__label,
.field-label {
  font-size: 1rem;
  font-weight: 700;
  color: #3f4254;
}

.preview-panel__body {
  margin-top: 0.75rem;
}

.score-box__value-wrap {
  margin-top: 0.75rem;
}

.media-wrap {
  width: 100%;
}

.media-player {
  width: 100%;
  max-height: 320px;
  border-radius: 0.5rem;
  background: #000;
}

.audio-box,
.comment-text-box {
  padding: 1rem;
  border: 1px solid #e4e6ef;
  border-radius: 0.75rem;
  background: #fff;
}

.audio-player {
  width: 100%;
  max-width: 420px;
}

.comment-text {
  margin-bottom: 0;
  white-space: pre-wrap;
  word-break: break-word;
}

.comment-empty {
  margin-bottom: 0;
  color: #7e8299;
  font-style: italic;
}

.clean-audio,
.clean-audio:hover,
.clean-audio:focus,
.clean-audio:active {
  box-shadow: none !important;
  -webkit-box-shadow: none !important;
  -moz-box-shadow: none !important;
  transform: none !important;
  -webkit-transform: none !important;
  -moz-transform: none !important;
  transition: none !important;
  -webkit-transition: none !important;
  -moz-transition: none !important;
  -o-transition: none !important;
  outline: none !important;
}
</style>
